import React, { useContext, useEffect, useState } from "react";
import "./Home.css";
import Section1 from "./section1/section1";
import Section2 from "./section2/section2";
import Section3 from "./section3/section3";
import Section4 from "./section4/section4";
import Section5 from "./section5/section5";
import Footer from "../Footer/Footer";
import TradeToEarnBanner from "./TradeToEarnBanner/TradeToEarnBanner";
import Modal from "../videoModal";
import { Popup } from "../../utils/PopupContest";
import LogoutPopup from "../updated/shared/LogoutPopup/LogoutPopup";
import { getAuthClient } from "./useZodiacSession";

import BitcoinyayBirthdayComponent from "./Bitcoinyay-birthday";
// import MeetingBanner from "./MeetingBanner/MeetingBanner";

const Home = () => {
  const popupDetails = useContext(Popup);
  const [show, setShow] = useState(popupDetails?.popup);
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);

  /*
   * The orphaned-legacy-token guard.
   *
   * ── What it is for ───────────────────────────────────────────────────────
   *
   * Before `shortToken` existed, sign-in wrote only `access_token`. A browser
   * still holding one of those has a session this app can no longer use, so
   * it is shown LogoutPopup — which is not a prompt: it clears localStorage
   * and redirects to /auth/login on a 2s timer, with no button and no way to
   * cancel.
   *
   * ── Why `!shortToken && access_token` is now wrong ───────────────────────
   *
   * Indexx ID produces exactly that combination legitimately. The Zodiac
   * bridge (applyEstateSession in zodiacAuth.js) writes access_token,
   * refresh_token, email, user, username and userType — and never shortToken,
   * because nothing in the OIDC flow mints one. Only the legacy password and
   * email logins write it.
   *
   * So as written, this fired on every Indexx ID session and wiped it two
   * seconds after the user reached the home page. Measured on test: sign in
   * anywhere in the estate, land on "/", and you are on /auth/login with an
   * empty localStorage — the exact opposite of single sign-on, on the one
   * page that advertises it.
   *
   * ── The fix ──────────────────────────────────────────────────────────────
   *
   * Ask the OIDC client whether this is a live session before concluding the
   * token is orphaned. And ask it only once the silent check has SETTLED:
   * getStatus() is "unknown" until then, so deciding at mount would reach the
   * same wrong answer a beat earlier.
   */
  useEffect(() => {
    const shortToken = localStorage.getItem("shortToken");
    const access_token = localStorage.getItem("access_token");

    // Either a legacy session that is fine, or no session at all.
    if (shortToken || !access_token) return;

    let cancelled = false;

    const decide = () => {
      if (cancelled) return;
      try {
        // A live Indexx ID session owns this access_token. Leave it alone.
        if (getAuthClient().getStatus() === "authenticated") return;
      } catch (_) {
        /* no client, or it threw — fall through to the legacy verdict */
      }
      setShowLogoutPopup(true);
    };

    try {
      const auth = getAuthClient();
      if (auth.hasAttemptedSilentSignIn()) decide();
      // Resolves, never rejects — but catch anyway: a guard that throws here
      // would leave a stale session in place silently.
      else auth.silentSignIn().then(decide).catch(decide);
    } catch (_) {
      decide();
    }

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    setShow(popupDetails?.popup);
    console.log(popupDetails?.popup);
  }, [popupDetails]);
  return (
    <>
      <Section1 />
      {/* <Section2 /> */}
      {/* <MeetingBanner /> */}
      {/* <BitcoinyayBirthdayComponent /> */}
      {/* <TradeToEarnBanner /> */}
      {/* <Section3 /> */}
      {/* <Section4 /> */}
      {/* <Section5 /> */}
      <Footer helpIcon={false} />
      <Modal show={false} onClose={setShow} />

      {showLogoutPopup && (
        <LogoutPopup onClose={() => setShowLogoutPopup(false)} />
      )}
    </>
  );
};

export default Home;
